export enum AGENT_MODAL_Z_INDEXES {
    UPGRADE_PROMPT_CUSTOMIZATION = 1000,
    UPGRADE_V2_DRAFT = 1100,
}
